import { FC } from 'react'
import { Container, ContainerLarge } from '../../container'
import { TimelineVideo } from '../video'
import { ReadMore } from '../../read-more'
import {
  TimelineTitle,
  TimelineTitleMask,
  TimelineIntro,
  TimelineSubtitle,
  TimelineContent,
  TimelineImage,
  TimelineAnchor,
} from '../styled'
import { texts } from '../../locale'
type Props = {
  scrollUp: boolean
}
export const Chapter_2: FC<Props> = ({ scrollUp }) => {
  return (
    <>
      <TimelineTitle>
        <TimelineAnchor id="chapter-2" $scrollUp={scrollUp} />
        <TimelineTitleMask />
        <img
          src={
            'https://gdb.rferl.org/0B66CB59-AE3E-4AB7-9130-ACA9E4AE9CE0_w1920_r4.jpg'
          }
        />
        <h2>
          <span>2</span>
          Донбас. Початок вторгнення
          <strong>{texts.menu_4}</strong>
        </h2>
      </TimelineTitle>

      <ContainerLarge>
        <TimelineIntro>
          На тлі української Революції гідності, яку Кремль називає державним
          переворотом, у східних обласних центрах – Луганську та Донецьку –
          починаються мітинги під російськими прапорами із закликами приєднання
          до Росії. Серед учасників цих зборів місцеві жителі помічають чимало
          приїжджих із прикордонних міст Росії – вони видають себе російською
          говіркою та незнанням українських міст. Як і в Криму, вони нападають
          на учасників акцій на підтримку суверенітету України. Ступінь
          насильства постійно зростає: доходить до вбивства учасника
          проукраїнської акції Дмитра Чернявського. З квітня місцеві органи
          влади на Донеччині і Луганщині починають штурмувати озброєні загони,
          якими командують офіцери армії Росії. Вони проводять незаконні
          затримання, у деяких приміщеннях міліції, СБУ утримують в’язнів.
          Останній масовий мітинг у Донецьку, який відбувався вже за умов
          захоплення адміністративних будівель проросійськими угрупованнями,
          зазнав нападу: травмовані учасники розбігалися містом, рятуючись.
          Проукраїнський опір було придушено. Цей гібридний період завершився
          штурмами українських військових частин, після чого заворушення
          перейшли у активну війну.
        </TimelineIntro>

        <TimelineContent>
          <TimelineSubtitle>1 березня</TimelineSubtitle>
          <p>
            У Луганську та Донецьку на мітингах під російськими прапорами люди
            закликають Кремль ввести війська в регіон для захисту від
            «західноукраїнського фашизму, який переміг в Україні». Такі ж тези
            під час Євромайдану просували російські федеральні ЗМІ. У Луганську
            мітингувальники захоплюють ОДА, в Донецьку – піднімають над обласною
            адміністрацією прапор Росії.
          </p>

          <TimelineSubtitle>3 березня</TimelineSubtitle>
          <p>
            Росія скупчує військову техніку на кордоні Луганської, Донецької,
            Харківської областей України та розгортає «пункти прийому біженців».
            Держприкордонслужба України повідомляє про спроби захоплення своїх
            органів управління на кордоні військовослужбовцями Росії.
            Відбувається мітинг під Донецькою ОДА під триколорами та зі
            скандуваннями «Росія!». Учасники без зброї займають будівлю. Міліція
            не втручається, проте 5 березня виводить мітингувальників із ОДА.
          </p>

          <TimelineSubtitle>5 березня</TimelineSubtitle>
          <p>
            На площі Леніна в центрі Донецька проходить мітинг місцевого
            Євромайдану за єдність України. На мітингарів із каміннями та битами
            нападають проросійські активісти: людей наздоганяють та б'ють,
            топчучи державні прапори. Біля Донецької ОДА збираються проросійські
            активісти, зокрема там присутній громадянин Росії Олексій Худяков,
            лідер ультраправої організації «Щит Москвы». Активісти знову
            штурмують ОДА, над нею піднімають прапор Росії. Цьому не заважають
            Внутрішні війська (попередник Нацгвардії), проте наступного дня
            міліція очищує приміщення та повертає український прапор на місце.
          </p>

          <TimelineSubtitle>9 березня</TimelineSubtitle>
          <p>
            У Луганську відбувається мітинг до 200-річчя від дня народження
            Тараса Шевченка та, на противагу йому, мітинг організації
            «Антимайдан», на якому скандують «Росія!». На «шевченківців» із
            травматичною зброєю та битами нападають проросійські активісти.
            Після цього нападники захоплюють Луганську адміністрацію та
            вивішують на ній російський прапор. На мітингу «Антимайдану»
            фіксують участь приїжджих із Бєлгородської і Ростовської областей
            Росії.
          </p>

          <ReadMore>
            {/*TODO: QUIOTE*/}
            <p>
              «Я особисто був свідком того, як на мітингу на вулиці Артема
              стояли нібито «шахтарі» – і при цьому вони прямо там запитували у
              мене, як пройти на вулицю Артема. Коли вони рвали українські
              прапори, то порвали заодно і прапор футбольного клубу «Шахтар»,
              навіть не знаючи, чого він стосується. Словом, усі ці «шахтарі»
              завозилися до нас здебільшого з Ростова і Бєлгорода. Звісно,
              місцеві також брали участь у цих заходах, особливо ті, кому участь
              в мітингах оплачували профспілки. Були й ті, хто щиро вірив у
              розповіді про «злих бандерівців» та обіцянки про те, що всі взяті
              у банках кредити будуть їм прощені» – протестантський пастор
              Олександр Хомченко, донеччанин.
            </p>

            {/*TODO: QUIOTE*/}
            <p>
              «Освободители» являли собою маргінес, звезений з усіх кінців
              Луганщини і Ростовської області Росії. Вони юрбилися в наметах, а
              у вільний час вешталися містом, розглядаючи його із роззявленими
              ротами» – радіожурналістка Ірина Коваль, луганчанка.
            </p>
          </ReadMore>

          <TimelineSubtitle>13 березня</TimelineSubtitle>
          <p>
            У Донецьку на мітингу за єдність України в результаті масового
            нападу проросійських сил вбито людину – Дмитра Чернявського. Десятки
            проукраїнських мітингувальників поранені.{' '}
            <a
              href="https://www.youtube.com/watch?v=8XptixrNpPs"
              target="_blank"
            >
              Нападники використовують
            </a>{' '}
            бити, арматуру, ножі, сльозогінний газ. Міліція практично не
            перешкоджає їм.
          </p>

          <TimelineSubtitle>23 березня</TimelineSubtitle>
          <p>
            У Луганську відбуваються два протилежні марші – за єдність України
            та за «референдум» щодо приєднання до Росії. Вони завершуються без
            агресії.
          </p>

          <TimelineSubtitle>6 квітня</TimelineSubtitle>
          <p>
            У Донецьку відбувається проросійський мітинг із вимогами провести
            «референдум» щодо входження до Росії, його учасники захоплюють ОДА і
            вивішують російський прапор. При захопленні застосовується граната.
            Це останнє і остаточне захоплення адміністрації. У Луганську
            учасники мітингу на підтримку Росії захоплюють обласне управління
            СБУ. Використовується каміння.
          </p>

          <TimelineSubtitle>8 квітня</TimelineSubtitle>
          <p>
            Починається{' '}
            <a href="https://www.radiosvoboda.org/a/airport-luhansk-2014/32353542.html">
              облога Луганського аеропорту
            </a>
            , що тривала 146 днів. До липня, коли бойові дії вже набули розмаху,
            українські бійці майже у повній темряві садили тут літаки:
            велетенські Іли підлітали до смуги взагалі без освітлення, й лиш
            тоді на лічені секунди вмикались ліхтарі. Так Україна здійснювала
            постачання своїх сил на Донбасі.
          </p>

          <TimelineImage>
            <img
              src={
                'https://gdb.rferl.org/9CF80CE1-09A1-4819-9575-E35811001817_w1000.jpg'
              }
            />
            <span>
              Руїни Міжнародного аеропорту Луганськ після його захоплення
            </span>
          </TimelineImage>

          <TimelineSubtitle>12 квітня</TimelineSubtitle>
          <p>
            Відбувається захоплення органів влади у Слов’янську і Краматорську.
            В останньому під час штурму місцевого управління міліції озброєний
            бойовик вимовляє фразу «отойди за поребрик», що стала мемом: цей
            діалектизм вживають у деяких регіонах Росії, але ніде в Україні.
            Захопленням Слов'янська керує російський полковник Ігор Гіркін, який
            приїхав сюди з уже окупованого Криму.
          </p>
          <TimelineVideo id={'u4zZGpUKrxI'} />

          <TimelineSubtitle>14 квітня</TimelineSubtitle>
          <p>
            Виконувач обов'язків президента Олександр Турчинов оголошує
            Антитерористичну операцію (АТО). Цього ж дня озброєні групи
            захоплюють управління внутрішніх справ Горлівки. Ними командує
            громадянин Росії Ігор Безлер. Він приймає «присягу» міліціонерів,
            які перейшли на бік проросійських сил, та представляється їм
            підполковником армії Росії.
          </p>
          <TimelineVideo id={'ElFPsRUqE8Y'} />

          <TimelineSubtitle>17 квітня</TimelineSubtitle>
          <p>
            У Горлівці викрадають депутата міськради Володимира Рибака, який до
            того намагався зняти російський прапор із будинку виконкому. Як
            розкажуть потім свідки, його та інших людей утримували і катували у
            захопленій будівлі міського СБУ. Тіло Рибака, студента Юрія Поправки
            та активіста Юрія Дяковського знайшли через три дні зі слідами
            тортур. Захоплена будівля СБУ пробуде тюрмою весь час окупації
            міста: там утримуватимуть, катуватимуть та виноситимуть смертні
            вироки під керівництвом російського полковника Ігоря Гіркіна.
          </p>

          <TimelineSubtitle>28 квітня</TimelineSubtitle>
          <p>
            У Донецьку відбувається останній мітинг за єдність України. На мирну
            ходу нападають люди у масках із битами та ланцюгами. Багато
            травмованих. На цьому громадянський спротив окупації в місті
            завершується.
          </p>

          <TimelineImage>
            <img
              src={
                'https://gdb.rferl.org/BB8CCE3D-B789-47FE-9F9E-FAADE50FEE59_w1000.jpg'
              }
            />
            <span>Мітинг у Донецьку 28 квітня</span>
          </TimelineImage>

          <TimelineSubtitle>3 травня</TimelineSubtitle>
          <p>
            Відбувається облога військового комісаріату та військової частини
            Національної гвардії в Луганську. Нападники використовують гранати
            та стрілецьку зброю.
          </p>

          <TimelineSubtitle>11 травня</TimelineSubtitle>
          <p>
            На захопленій частині регіону збройні угрупування під керівництвом
            Росії проводять псевдореферендуми про створення так званих
            «Донецької і Луганської народних республік». Це фіктивне голосування
            здійснюється без жодних визнаних світом спостережних місій.
          </p>

          <TimelineSubtitle>22 травня</TimelineSubtitle>
          <p>
            Озброєні формування захоплюють органи влади у Лисичанську,
            Сєвєродонецьку та Рубіжному.
          </p>
        </TimelineContent>
      </ContainerLarge>
    </>
  )
}
